import { joinDataTestId } from "@/constants/data-test-ids.utils";

const component = "active-subscription-card";

export const activeSubscriptionCardDataTestIds = {
  component,
  header: joinDataTestId(component, "header"),
  statusBadge: joinDataTestId(component, "status-badge"),
  attentionBadge: joinDataTestId(component, "attention-badge"),
  timeline: joinDataTestId(component, "timeline"),
  eligibilityRow: joinDataTestId(component, "eligibility-row"),
  installationRow: joinDataTestId(component, "installation-row"),
  prospectionRow: joinDataTestId(component, "prospection-row"),
  tagsRow: joinDataTestId(component, "tags-row"),
  tagsSelect: joinDataTestId(component, "tags-select"),
  tagChip: (path: string): string => joinDataTestId(component, "tag-chip", path),
  tagRemoveCta: (path: string): string => joinDataTestId(component, "tag-remove-cta", path),
  documentsRow: joinDataTestId(component, "documents-row"),
  confirmEligibilityCta: joinDataTestId(component, "confirm-eligibility-cta"),
  createSubscriptionCta: joinDataTestId(component, "create-subscription-cta"),
  reOpenSubscriptionCta: joinDataTestId(component, "re-open-subscription-cta"),
  takeAppointmentCta: joinDataTestId(component, "take-appointment-cta"),
  viewHistoryCta: joinDataTestId(component, "view-history-cta"),
  pastFailuresNotice: joinDataTestId(component, "past-failures-notice"),
  pastFailuresNoticeCta: joinDataTestId(component, "past-failures-notice-cta"),
  actionsMenuCta: joinDataTestId(component, "actions-menu-cta"),
  actionsMenu: joinDataTestId(component, "actions-menu"),
  toggleRowsCta: joinDataTestId(component, "toggle-rows-cta"),
  delayedClosureBlock: joinDataTestId(component, "delayed-closure-block"),
  delayedClosureReason: joinDataTestId(component, "delayed-closure-reason"),
  delayedClosureDate: joinDataTestId(component, "delayed-closure-date"),
  delayedClosureOperator: joinDataTestId(component, "delayed-closure-operator"),
  delayedClosureLifted: joinDataTestId(component, "delayed-closure-lifted"),
};
